import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Paper from '@material-ui/core/Paper'

import FrCheckBox from '../components/FrCheckBox'
import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';

const swal = withReactContent(Swal)

function Usuarios() {
  const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [comboGrupoUsu, setComboGrupoUsu] = useState([{ value: '', display: '' }])
  const [comboAtivo, setComboAtivo] = useState([{ value: '', display: '' }])
  const [erroEmail, setErroEmail] = useState(false)
  const [comboPve, setComboPve] = useState([{ value: '', display: '' }])
  const [tipoGrupo, setTipoGrupo] = useState('')
  const [comboCad, setComboCad] = useState([{ value: '', display: '' }])
  const [comboParceiro, setComboParceiro] = useState([{ value: '', display: '' }])
  const [comboRepresentante, setComboRepresentante] = useState([{ value: '', display: '' }])
  const [comboUsu, setComboUsu] = useState([{ value: '', display: '' }])

  useEffect(() => {

    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      setComboGrupoUsu(await api.getComboData('grupo_usuarios'))

      setComboPve(await api.getComboData('vendedores', null, 'id=' + auth.user))
      setComboCad(await api.getComboData('cadastro', 'A'))
      setComboParceiro(await api.getComboData('cadastro', 'P'))
      setComboRepresentante(await api.getComboData('cadastro', 'R'))
      setComboUsu(await api.getComboData('usuario'))

      setComboAtivo([

        {
          "value": "S",
          "display": "Sim",
        },
        {
          "value": "N",
          "display": "Não",
        },

      ])
      console.log(query.codigo)
      if (query.codigo) {
        setUpdateType(true)
        api.get('/usuario_externo?pk_uex=' + query.codigo).then(r => {
          console.log(query.codigo)
          if (r.data[0]) {
            console.log(r.data[0])
            let auxValues = {...r.data[0]}
            auxValues.CHECK_LIMITE = (r.data[0].LIBERA_IDADE == 'S' ? true : false)
            setData(auxValues)

            api.get('/grupo_usuarios?pk_gru=' + r.data[0].FK_GRU).then(r => {
              if (r.data[0])
                setTipoGrupo(r.data[0].TIPO_GRUPO)
            })

            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'EMAIL',
      'FK_GRU'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr === 'FK_GRU') fieldName = 'GRUPO DE USUÁRIO'
      if (!data[curr]) return errors.push(fieldName)

      if (erroEmail && (errors.indexOf('EMAIL') === -1)) errors.push('EMAIL')

    })

    return errors
  }


  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.host = window.location.href;
        let errors = consistData(auxValues)
        console.log(errors.length)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/usuario_externo/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alterado',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
            api.post('/usuario_externo/add', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    // auxValues[e.target.name] = e.target.value;
    switch (e.target.name) {
      case 'FK_GRU':
        api.get('/grupo_usuarios?pk_gru=' + e.target.value).then(r => {
          setTipoGrupo(r.data[0].TIPO_GRUPO)

        })
        auxValues[e.target.name] = e.target.value;
        break;
      case 'CHECK_LIMITE':
        auxValues[e.target.name] = e.target.checked
        break

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };


  function handleEmail(e) {
    e.preventDefault();
    if (e.target.value) {
      if (e.target.value.indexOf('@') === -1) {
        setErroEmail(true)
        swal.fire('Email inválido', 'Informe um email válido!', 'warning')
      } else setErroEmail(false)
    }
  }

  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h1>{updateType ? 'Edição' : 'Inclusão'} de Usuário</h1>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='45'
            value={data.EMAIL || ''}
            onChange={handleChange}
            onBlur={handleEmail}
            name="EMAIL"
            id="EMAIL"
            color="#F1873B"
            label="E-mail"
            variant="outlined"
            size="small"
            required
            style={{ width: 500 }}
          />
          <FrSelect
            value={data.FK_GRU || ''}
            onChange={handleChange}
            name="FK_GRU"
            id="FK_GRU"
            label='Grupo de Usuário'
            data={comboGrupoUsu}
            style={{ width: 250 }}
          />
          <FrSelect
            value={data.ATIVO || ''}
            onChange={handleChange}
            name="ATIVO"
            id="ATIVO"
            label={(updateType) ? 'Ativo' : ''}
            data={comboAtivo}
            style={{ width: 100 }}
            hidden={!updateType}
          />

          <FrSelect
            value={data.FK_PVE || ''}
            onChange={handleChange}
            name="FK_PVE"
            id="FK_PVE"
            label={(tipoGrupo !== 'V') ? '' : 'Vendedor'}
            data={comboPve}
            style={{ width: 250 }}
            hidden={tipoGrupo !== 'V'}
          />
          <FrSelect
            value={data.FK_CAD || ''}
            onChange={handleChange}
            name="FK_CAD"
            id="FK_CAD"
            label={(tipoGrupo === 'A') ? 'Associado' : ''}
            data={comboCad}
            style={{ width: 250 }}
            hidden={(tipoGrupo !== 'A')}
          />

          <FrSelect
            value={data.FK_CAD || ''}
            onChange={handleChange}
            name="FK_CAD"
            id="FK_CAD"
            label={(tipoGrupo === 'P') ? 'Parceiro de Venda' : ''}
            data={comboParceiro}
            style={{ width: 250 }}
            hidden={(tipoGrupo !== 'P')}
          />

          <FrSelect
            value={data.FK_CAD || ''}
            onChange={handleChange}
            name="FK_CAD"
            id="FK_CAD"
            label={(tipoGrupo === 'R') ? 'Representante' : ''}
            data={comboRepresentante}
            style={{ width: 250 }}
            hidden={(tipoGrupo !== 'R')}
          />

          <FrSelect
            value={data.FK_USU || ''}
            onChange={handleChange}
            name="FK_USU"
            id="FK_USU"
            label={(tipoGrupo === 'M') ? 'Usuário Sistema' : ''}
            data={comboUsu}
            style={{ width: 250 }}
            hidden={(tipoGrupo !== 'M')}
          />
            <FrCheckBox text={
              `Libera limite de idade`
            } onChange={handleChange} name="CHECK_LIMITE" id="CHECK_LIMITE" checked={data.CHECK_LIMITE || false} />


        </form>
        <div className="regButtonsDiv">
          <button onClick={handleSubmit}>Salvar</button>
          <button onClick={handleCancel}>Cancelar</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Usuarios;
